import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Reviews() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Indulge in the world of fine dining with First-Class.com. Read expert reviews of top restaurants and culinary experiences, and savor gourmet delights'
          }
        />
        <title>Dining Reviews: Honest Restaurant Assessments</title>
      </Head>
      <ArticlesList subtype="Reviews" type="Dining" />
    </>
  );
}

export default withLayout(Reviews, true);
